import React from 'react';
export function CountdownTimer() {
  return <div className="fixed top-0 left-0 w-full bg-red-600 text-white py-3 z-50 shadow-md text-center font-bold text-lg md:text-xl animate-pulse" data-id="element-107">
      <div className="container mx-auto px-4 flex justify-center items-center gap-2" data-id="element-108">
        <span data-id="element-109">⚠️ ESTA OFERTA TERMINA PRONTO:</span>
        <span className="font-mono bg-red-800 px-2 py-0.5 rounded" data-id="element-110">10:48</span>
      </div>
    </div>;
}